import React, { createContext, useState } from "react";
import { useEffect } from "react";

import { getUserStoreId, hasLockedStore } from "../helpers/permissions";

const StoreContext = createContext();

const savedStoreId = (storeId = 0) => {
  const saveStoreId = localStorage.getItem("storeId")
  if (saveStoreId) {
    if (storeId && storeId !== saveStoreId) {
      localStorage.setItem("storeId", storeId)
    }
    return saveStoreId
  }
  return null
}

const StoreContextProvider = ({ children }) => {
  // Store managers and Operations staff work on their own store only; admins
  // pick one in the header.
  const locked = hasLockedStore();
  const [storeId, setStoreId] = useState(() => (locked ? getUserStoreId() : savedStoreId()));

  useEffect(() => {
    if (!locked) savedStoreId(storeId)
  }, [locked, storeId])

  const selectStore = (id) => {
    if (!locked) setStoreId(id)
  }

  return (
    <StoreContext.Provider
      value={{ storeId: storeId, setStoreId: selectStore }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export { StoreContext, StoreContextProvider };
